import { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

import { legacyDashboardURL } from '@helpers';

export const GlobalContext = createContext();

const handleDashboardRestrictions = (authData) => {
  // based on initial auth response, handle any restrictions
  //
  // including bouncing the visitor to the legacy dashboard if
  // they dont have permission to the new dashboard on their group
  const restrictDashboards = authData.group_settings.restrict_dashboards;
  if (restrictDashboards.length == 1 && restrictDashboards.includes('legacy')) {
    // handle legacy only rendering
    window.location = legacyDashboardURL('/app/');
    return true;
  }

  return false;
};

const setVisible = (authData) => {
  // get default visibility of features
  let defaultVisibility = true;
  if ('default_visibility' in authData.group_settings) {
    defaultVisibility = authData.group_settings.default_visibility;
  }

  // local storage flag to expose features
  const devFeatures = window.localStorage.getItem('sbdev') == 'true';
  // is the current user a superadmin (i.e. demo@cloudbackend.net)
  const isSuperAdmin = authData.user.is_staff;
  // group-based visibility settings
  const groupDashboardVisibility =
    authData.group_settings.dashboardVisibility || {};

  // set that we have recieved data
  // if not, users might be redirected unintentionally
  authData.isLoaded = true;
  // set the visible keys based on the current user/whitelabel
  authData.visible = {
    legacyDashboardLink:
      authData.group_settings.restrict_dashboards.includes('legacy'),
    locationDetailsView: defaultVisibility,
    locationSettingsView: defaultVisibility,
    locationSocialView: defaultVisibility,
    organizationView: defaultVisibility,
    projectsView: defaultVisibility,
    projectContentDatabaseView: defaultVisibility,
    projectDataModelsView: defaultVisibility,
    projectLocationsView: defaultVisibility,
    projectSettingsView: defaultVisibility,
    projectTemplatesView: defaultVisibility,
    projectFormLeadsView: defaultVisibility,
    siteAccessView: defaultVisibility,
    siteBlogsView: defaultVisibility,
    siteBlogAuthorsView: defaultVisibility,
    siteBlogCategoriesView: defaultVisibility,
    siteLocationView: defaultVisibility,
    sitePagesView: defaultVisibility,
    siteSettingsView: defaultVisibility,
    usersView: defaultVisibility,
    groupsView: defaultVisibility,
    websiteViewPreview: defaultVisibility,
    websitesFiltering: defaultVisibility,
    siteSEOView: defaultVisibility,
    projectBulkEditView: false,
    ...groupDashboardVisibility,
  };

  console.log('registered auth data', authData);
  return authData;
};

// Create a context provider component
export const GlobalProvider = ({ children }) => {
  // initial state and required variabled for rendering
  const [globalProps, setGlobalProps] = useState({
    isLoaded: false,
    perms: {
      Business: [],
      Site: [],
    },
    user: {
      first_name: ' ',
      last_name: '...',
    },
    visible: {},
    whitelabel: {
      partner_name: '...',
      oneoff_access_group_ids: {},
      whitelabel_domain: 'devhub.com',
      settings: {},
    },
  });
  const matches = useLocation();

  const handleUnauthorized = () => {
    // handle if the user is unauthorized/ logged out
    window.location = legacyDashboardURL(
      '/accounts/signin/?next=' + location.pathname,
    );
  };

  useEffect(() => {
    const query = axios
      .get(`/resources/auth_details/`)
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // not authorized, logged out
          handleUnauthorized();
        }
      })
      .then((response) => {
        // check for access restrictions
        const restricted = handleDashboardRestrictions(response.data);
        if (restricted) {
          return;
        }
        document.title = `${response.data.whitelabel.partner_name} - DevHub`;
        setGlobalProps(setVisible(response.data));
      });
  }, []);

  return (
    <GlobalContext.Provider value={globalProps}>
      {children}
    </GlobalContext.Provider>
  );
};
